import React from 'react';
import { Dot } from '../components';

class StatusGridCell extends React.Component {

    static get status() {
        return Dot.status;
    }

    render () {
        return (
            <Dot className={['component-dot', this.props.className].join(' ')} status={this.props.data + ''} />
        )
    }
}

export default StatusGridCell;



// WEBPACK FOOTER //
// ./web-app/components/status-grid-cell.jsx